import Vue from "vue"
import Router from "vue-router"

import Login from "./views/Login.vue"

import MandatesRoot from "@/views/Mandates.vue";
import MandatesCreate from "@/views/MandatesCreate.vue";
import MandatesDetail from "@/views/MandatesDetail.vue";
import Packages from "@/views/Packages.vue";
import PackagesDetail from "@/views/PackagesDetail.vue";
import Newsletter from "./views/Newsletter.vue"
import Update from "@/views/Update.vue";

import LoginStore from "@/ts/stores/LoginStore";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "/",
            name: "login",
            component: Login
        },
        {
            path: "/mandates",
            name: "mandates",
            component: MandatesRoot
        },
        {
            path: "/mandates/create",
            name: "mandates_create",
            component: MandatesCreate
        },
        {
            path: "/mandates/edit",
            name: "mandate.edit",
            component: MandatesDetail
        },
        {
            path: "/packages/edit",
            name: "packages.edit",
            component: PackagesDetail
        },
        {
            path: "/packages",
            name: "packages",
            component: Packages
        },
        {
            path: "/news",
            name: "news",
            component: Newsletter
        },
        {
            path: "/formulars/update",
            name: "update",
            component: Update
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.name !== "login" && LoginStore.state.authToken === "") {
        next("/")
    } else {
        next()
    }
});

export default router;
